import { Expense, Ticket } from '../../state/types'
import { useEffect, useMemo, useState } from 'react'
import { fileNameFromUrl, DownloadFilesModal, FileOption } from '../../../../features/files'
import { useTicketLoaders, useExpenseHooks } from '../../../administration'

type Props = {
    expense?: Expense
}

export const DownloadExpenseFilesModal = (props: Props) => {
    const { expense } = props

    const [tickets, setTickets] = useState<Ticket[]>([])

    const { isSalary } = useExpenseHooks()
    const ticketLoaders = useTicketLoaders()

    useEffect(() => {
        if (expense) {
            ticketLoaders().loadParentTickets(expense.id).then(setTickets)
        }
    }, [expense])

    const fileOptions = useMemo(() => {
        if (!expense) return []
        
        const options: FileOption[] = []

        const label = isSalary(expense) ? 'Recibo' : 'Factura'
        tickets.filter(ticket => ticket.ticketUrl).forEach(ticket => {
            options.push({
                id: `ticket-${ticket.code}`,
                label: `${label} #${ticket.code}`,
                fileName: fileNameFromUrl(ticket.ticketUrl)!,
                url: ticket.ticketUrl
            })
        })

        return options
    }, [expense, tickets])
    
    return <DownloadFilesModal fileOptions={fileOptions} />
}
